import React, { useEffect } from 'react'
import Contact from '../Components/Contact'

const Contactpage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top when component loads
      }, []);
  return (
    <div className='py-20'>
      <Contact/>
    </div>
  )
}

export default Contactpage
